import React, { useEffect, useState } from "react";
import { Button, Card, Form, Modal, Col, Row } from "react-bootstrap";
import { useLazyQuery } from "@apollo/client";

import { GET_USER } from "schemas/profile";
import { GlobalState } from "contexts/GlobalState";

import closeBtn from "assets/img/x_icon.png";

import "./style.scss";

export const RegisterModalContent = ({ labels, handleClose, lastAction, programName }) => {
  const [loginValidated, setLoginValidated] = useState(false);
  const [registValidated, setRegistValidated] = useState(false);
  const [showVerifyLogin, setShowVerifyLogin] = useState(false);
  const [showVerifyRegist, setShowVerifyRegist] = useState(false);
  const [login, setLogin] = useState(false);
  const [globalUser, setGlobalUser] = GlobalState("user");
  const [formerrors, setFormErrors] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [checked, setChecked] = useState(true);
  const [registerFields, setRegisterFields] = useState({
    id: 0,
    email: "",
    phone: "",
    fullName: "",
    password: "",
    checkbox:"false"
  });

  const [loginFields, setLoginFields] = useState({
    email: "",
    password: ""
  })

  const [getUser, { loading: userLoading, data: userData }] = useLazyQuery(GET_USER, {
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (!userLoading && userData) {
      setGlobalUser({ ...userData, loading: userLoading })
    }
  }, [userLoading, userData])

  useEffect(() => {
    if (globalUser && lastAction?.action) {
      lastAction.action(lastAction.params);
    }
  }, [globalUser])

  const validate = (form) => {
    let  formFields=registerFields;
    if(form=="regist"){
      setLogin(false)
       formFields=registerFields;
    }
    else{
      setLogin(true)
      formFields=loginFields;
    }
    let errors = {};

    if (formFields.fullName=="") {
      errors.fullname = labels.fullNamePlaceholder +" " +labels.required
    }
    else
    {
     if(!/^[a-zA-Z\u0590-\u05FF\u200f\u200e]{2,}\s[a-zA-Z\u0590-\u05FF\u200f\u200e ]{1,}$/.test(formFields.fullName))
     errors.fullname=labels.fullNamePlaceholder +" " +labels.Invalid
    }
    if (!formFields.email) {
      errors.email = labels.emailPlaceholder+" " + labels.required
    } else if (!/\S+@\S+\.\S+/.test(formFields.email)) {
      errors.email = labels.emailPlaceholder +" "+labels.Invalid
    }
    if (!formFields.phone) {
      errors.phone = labels.phoneNumPlaceholder +" " +labels.required
    }
    else if (!/[0-9]{10}/.test(formFields.phone)) {
      errors.phone = labels.phoneNumPlaceholder +" "+labels.Invalid
    }
    
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      return true;
    } else {
      return false;
    }
  };

  const createRequestMetaData = (postBody) => {
    const requestMetadata = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postBody),
    };

    return requestMetadata;
  }
  const focusOnFirstInvalidInput = (formElement) => {
    const inputs = formElement.querySelectorAll('input');
    Array.from(inputs).every(form_input => {
      if (!form_input.checkValidity()) {
        form_input.focus();
        return false;
      }
      return true;
    })
  }
  const postLoginOrRegisterDataToProfile = async (route, requestMetadata, resend = false) => {
    let response;
    try {
      response = await fetch(`${window.location.origin}/auth/${route}`, requestMetadata)
      const resBody = await response.json();
      if (response.status == 200) {
        alert(resend ? labels.alertCodeResent : labels.alertCodeSent);
        if (route === "login") {
          setShowVerifyLogin(true);
          document.getElementById("formConfirmLogin").focus();
        }
        else {
          setShowVerifyRegist(true);
          document.getElementById("formConfirmRegister").focus();
        }
      }
      if (response.status == 400) {
        if (resBody.error === "no user with that email") {
          alert(labels.alertNoUserWithEmail);
        } else if (resBody.error === "there's already a user with that email") {
          alert(labels.alertAlreadyUserWithEmail);
        } else {
          alert(labels.alertError);
        }
      }
    }
    catch {
      if (response.status == 429) { // Too Many Requests
        alert(labels.tooManyRequests);
      } else {
        alert(labels.alertError);
      }
    }
  }
  const handleChange = (field, target, form) => {
    setShowMessage(false);
    if (target.value)
      if (form === "regist") {
        if(field=='checkbox')
        {
          setRegisterFields((prevState) => ({ ...prevState, [field]: target.checked.toString() }));
          setChecked(!checked)
        }
        else{
          setRegisterFields((prevState) => ({ ...prevState, [field]: target.value }));
        }
      } else if (form === "login") {
        setLoginFields((prevState) => ({ ...prevState, [field]: target.value }));
      }
  };

  const handleSubmit = (e, form) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.currentTarget.checkValidity() === true) {
      if (form === "regist") {
        const postBody = {
          email: registerFields.email,
          phone: registerFields.phone,
          fullName: registerFields.fullName,
          checkbox:registerFields.checkbox,
          form: form,
        };
        const requestMetadata = createRequestMetaData(postBody);
        postLoginOrRegisterDataToProfile("register", requestMetadata);

      } else if (form === "login") {
        const postBody = {
          email: loginFields.email,
        }
        const requestMetadata = createRequestMetaData(postBody);
        postLoginOrRegisterDataToProfile("login", requestMetadata);
      }
    }
    else {
      focusOnFirstInvalidInput(e.target);
      if (validate(form)) {
        setShowMessage(false);
      } else {
        setShowMessage(true);
      }
    }

    form == "regist" ? setRegistValidated("true") : setLoginValidated("true");
  };

  const confirmUserSubmit = async (e, form) => {
    e.preventDefault();
    let postBody = {};
    if (form === "regist") {
      postBody = {
        password: registerFields.password,
      };
    } else if (form === "login") {
      postBody = {
        password: loginFields.password,
      };
    }
    const requestMetadata = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postBody),
    };

    try {
      const response = await fetch(`${window.location.origin}/auth/confirm`, requestMetadata);
      const resBody = await response.json();
      if (response.status == 200) {
        alert(labels.alertSuccess);
        getUser();
        window.location.href = labels.profile_url;
      }
      if (response.status == 400) {
        if (resBody.error === "wrong password") {
          alert(labels.alertWrongCode);
        } else {
          alert(labels.alertError);
        }
      }
    }
    catch (e) {
      alert(labels.alertError);
    }
  };

  const resendCode = (e, formName) => {
    e.preventDefault();
    e.stopPropagation();
    const formElement = document.getElementById(`${formName}Form`);
    if (formElement.checkValidity() === true) {
      const postBody = {};
      if (formName === "login") {
        postBody.email = loginFields.email;
      } else {
        postBody.email = registerFields.email;
      }
      const requestMetadata = createRequestMetaData(postBody);
      const resend = true;
      postLoginOrRegisterDataToProfile("login", requestMetadata, resend);
    } else {
      focusOnFirstInvalidInput(formElement);
    }
    formName == "regist" ? setRegistValidated("true") : setLoginValidated("true");
  }

  const updateFocus = (e,id) => {
    if (e.key === 'Enter'){
      document.getElementById(id).focus();
    }
  }

  const renderRegisterForm = () => {
    return (
      <React.Fragment>
        <Form
          noValidate
          validated={registValidated}
          onSubmit={(e) => handleSubmit(e, "regist")}
          id="registForm"
        >
          <Form.Control
            type="text"
            //pattern of full name (2 words of 2+ letters with space in the middle)
            pattern="^[a-zA-Z\u0590-\u05FF\u200f\u200e]{2,}\s[a-zA-Z\u0590-\u05FF\u200f\u200e ]{2,}$"
            placeholder={labels.fullNamePlaceholder}
            aria-label={labels.fullNamePlaceholder + labels.required}
            aria-describedby="fullnameError"
            className="placeholder profile-icon"
            onChange={(e) => handleChange("fullName", e.target, "regist")}
            required
          />
          {formerrors.fullname && showMessage && !login &&(
          <p id="fullnameError" class="errorMessage">{formerrors.fullname}</p>
         )}
          <Form.Control
            type="email"
            placeholder={labels.emailPlaceholder}
            aria-label={labels.emailPlaceholder + labels.required}
            aria-describedby="emailError"
            className="placeholder email-icon"
            onChange={(e) => handleChange("email", e.target, "regist")}
            required
          />
        {formerrors.email && showMessage && !login &&(
       <p id="emailError"class="errorMessage">{formerrors.email}</p>
      )}
          <Form.Control
            type="tel"
            placeholder={labels.phoneNumPlaceholder}
            dir="rtl"
            aria-label={labels.phoneNumPlaceholder + labels.required}
            aria-describedby="phoneError"
            className="placeholder phone-icon"
            pattern="[0-9]{10}"
            onChange={(e) => handleChange("phone", e.target, "regist")}
            required
          />
          {formerrors.phone && showMessage && !login &&(
       <p id="phoneError" class="errorMessage" >{formerrors.phone}</p>
      )}
          <Form.Check
            type="checkbox"
            label={labels.formCheck}
            aria-label={labels.formCheck}
            aria-required="true"
            aria-describedby={labels.formCheck}
            name="checked"
            checked={checked}
            onChange={(e) => handleChange("checkbox", e.target, "regist")}
            className="checkbox-updates"
          />
          <Button aria-label={labels.createAccount} className="login-signup-button" type="submit">
            {labels.createAccount}
          </Button>
        </Form>
        {showVerifyRegist && (
          <Form>
            <Form.Group controlId="formConfirmRegister" >
              <Form.Control
                type="number"
                placeholder={labels.verificationCode}
                aria-label={labels.verificationCode}
                className="placeholder confirm-icon"
                onChange={(e) => handleChange("password", e.target, "regist")}
                onKeyDown={(e) => updateFocus(e,"regist")}
              />
              <Button
                id="regist"
                aria-label={labels.confirmCode}
                className="confirm-button"
                onClick={(e) => confirmUserSubmit(e, "regist")}
              >
                {labels.confirmCode}
              </Button>
              <button className="resend-btn" onClick={(e) => resendCode(e, "regist")}>
                {labels.didntGetCode}
              </button>
            </Form.Group>
          </Form>
        )}
      </React.Fragment>
    )
  }

  const renderLoginForm = () => {
    return (
      <>
        <Form
          noValidate
          validated={loginValidated}
          onSubmit={(e) => handleSubmit(e, "login")}
          id="loginForm"
        >
          <Form.Control
            type="email"
            placeholder={labels.emailPlaceholder}
            aria-label={labels.emailPlaceholder + labels.required}
            className="placeholder email-icon"
            onChange={(e) => handleChange("email", e.target, "login")}
            aria-describedby="emailLoginError"
            required
          />
           {formerrors.email && showMessage && login &&(
            <p id="emailLoginError" class="errorMessage" >{formerrors.email}</p>)}
          <Button aria-label={labels.signin} className="login-signup-button" type="submit">
            {labels.signin}
          </Button>
        </Form>
        {showVerifyLogin && (
          <Form>
            <Form.Group controlId="formConfirmLogin">
              <Form.Control
                type="text"
                placeholder={labels.verificationCode}
                aria-label={labels.verificationCode}
                className="placeholder confirm-icon"
                onChange={(e) => handleChange("password", e.target, "login")}
                onKeyDown={(e) => updateFocus(e,"login")}
              />
              <Button
                id="login"
                aria-label={labels.confirmCode}
                className="confirm-button"
                onClick={(e) => confirmUserSubmit(e, "login")}
              >
                {labels.confirmCode}
              </Button>
              <button className="resend-btn" onClick={(e) => resendCode(e, "login")} >
                {labels.didntGetCode}
              </button>
            </Form.Group>
          </Form>
        )}
      </>
    )
  }

  return (
    <>
      <Modal.Header>
        <Modal.Body>
          <button data-dismiss="modal" id="close-modal-btn" onClick={handleClose} >
            <img src={closeBtn} className="close-img" />
          </button>
        </Modal.Body>
      </Modal.Header>
      <Modal.Body>
        <Row className="justify-content-start header">
          <div className="img" />
          <Col className="content-col">
            <div className="text-wrapper">
              <h3 tabIndex="0" className="label">{labels.label}</h3>
              {programName &&
                <p className="favoriteProgram">{`${labels.favoriteProgram1} ${programName} ${labels.favoriteProgram2}`}</p>
              }
              <p tabIndex="0" className="promo">{labels.promo}</p>
            </div>
            {Utils.isMobile() && (
              <>
                <div className="prompt">
                  <h3 tabIndex="0">{login ? labels.signinPrompt : labels.signupPrompt}</h3>
                </div>
                {login ? (
                  renderLoginForm()
                ) : (
                  renderRegisterForm()
                )}
                <button className="switch-btn" onClick={() => setLogin(prevState => !prevState)}>
                  {login ? labels.createUser : labels.alreadyUser}
                </button>
              </>
            )}
          </Col>
        </Row>
        {!Utils.isMobile() && (
          <Row className="justify-content-center cards-wrap">
            <Card sm={12} md="true" className="login-card">
              <Card.Body>
                <Card.Title className="prompt">
                  <h4 tabIndex="0">{labels.signupPrompt}</h4>
                </Card.Title>
                {renderRegisterForm()}
              </Card.Body>
            </Card>

            <Card sm={12} md="true" className="login-card">
              <Card.Body>
                <Card.Title className="prompt">
                  <h4 tabIndex="0">{labels.signinPrompt}</h4>
                </Card.Title>
                {renderLoginForm()}
              </Card.Body>
            </Card>
          </Row>
        )}
        <Row sm={1} md={5} className="justify-content-space-evenly login-footer">
          <Col>
            <div className="login-calculator-img" tabIndex="0" aria-labelledby="calcText"></div>
            <p id="calcText">{labels.calculatorText}</p>
          </Col>

          <Col>
            <div className="login-info-img" tabIndex="0" aria-labelledby="infoText"></div>
            <p id="infoText">{labels.infoText}</p>
          </Col>

          <Col>
            <div className="login-reload-img" tabIndex="0" aria-labelledby="updatesText"></div>
            <p id="updatesText">{labels.updatesText}</p>
          </Col>

          <Col>
            <div className="login-edit-img" tabIndex="0" aria-labelledby="editText"></div>
            <p id="editText">{labels.editText}</p>
          </Col>
          <Col>
            <div className="login-settings-img" tabIndex="0" aria-labelledby="manageText"></div>
            <p id="manageText">{labels.manageText}</p>
          </Col>
        </Row>
      </Modal.Body>
    </>
  )

}